import React from "react";
import Icon from "assets/icons";
import classNames from "classnames";
import { TitlePropTypes } from "./types";

function Title({ wrapperClass = "titleWrapper", ...props }: TitlePropTypes) {
  const { inline, inlineBadge, inlineSubTitle } = React.useMemo(() => {
    let inline = false,
      inlineBadge = false,
      inlineSubTitle = false;

    if (!props.option?.isInline) return { inlineBadge, inlineSubTitle, inline };

    if (props.count && props.subTitle) inline = true;
    else if (props.count) inlineBadge = true;
    else if (props.subTitle) inlineSubTitle = true;

    return {
      inline,
      inlineBadge,
      inlineSubTitle
    };
  }, [props.count, props.subTitle, props.option?.isInline]);

  return (
    <div className={classNames(wrapperClass, { inline: inline, inlineSubTitle: inlineSubTitle })}>
      <span
        className={classNames(`${wrapperClass}_title`, { inlineBadge: inlineBadge })}
        title={typeof props.title === "string" ? props.title : ""}>
        {props.option?.icon && <span className={`${wrapperClass}_title--icon`}>{props.option?.icon}</span>}
        <span className={`${wrapperClass}_title--text`}>{props.title}</span>
        {props.option?.showHoverActionIcon && <Icon.FlatNextArrow className="hoverArrow" />}
        {Boolean(props.count) && <span className={`${wrapperClass}_title--badge`}>{props.count}</span>}
      </span>
      {props.subTitle ? (
        typeof props.subTitle === "string" ? (
          <span className={`${wrapperClass}_subTitle`} title={props.subTitle}>
            {props.subTitle}
          </span>
        ) : (
          props.subTitle
        )
      ) : null}
    </div>
  );
}

export default Title;
